import { FunctionComponent } from 'react';
import { withStyles } from '../../../utils/utils';
import Box from '../../Layout/Box/Box';
import Button from '../../Input/Button/Button';
import styles from './ShareSheet.module.scss';

export interface ShareSheetProps {
  content: React.JSX.Element;
  isVisible: boolean;
  setIsVisible: (val: boolean) => void;
}

const ShareSheet: FunctionComponent<ShareSheetProps> = ({
  content,
  isVisible = false,
  setIsVisible,
}: ShareSheetProps) => {
  const classes = withStyles(styles);

  return (
    <div className={classes('sharesheet', isVisible && 'visible')}>
      <Box flx="col">
        <Box jc="fe" height="auto" padding="24px 24px 16px 24px">
          <Button
            id="close-sharesheet-button"
            label=""
            noShadow
            noPadding
            isCircle
            width="24px"
            height="24px"
            background="#E6E6E6"
            icon="cross"
            iconColor="primary-dark"
            iconWidth="8px"
            iconHeight="8px"
            iconLocation="center"
            onClick={() => {
              setIsVisible(false);
            }}
          />
        </Box>
        <div style={{ height: 'calc(780px - 64px' }}>{content}</div>
      </Box>
    </div>
  );
};

export default ShareSheet;
